
import { tailwindSurfaceFontClass } from 'bits/font'
import { transformCurrentUrl } from 'bits/location'
import { isRegistered } from 'bits/user_model'
import { Component, Getter, namespace, Prop, State, Vue, Watch } from 'bits/vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import type { User } from 'types'
import ProcessedImage from 'vuecomponents/processed_image.vue'
import SurfaceBuilder from 'vuecomponents/SurfaceBuilder.vue'
import SurfaceTitleDescription from 'vuecomponents/SurfaceTitleDescription.vue'

@Component({
  components: {
    ProcessedImage,
    SurfaceBuilder,
    OzIcon,
    SurfaceTitleDescription,
  },
})
export default class SurfaceTitleMobile extends Vue {
  $el!: HTMLDivElement
  $refs!: {
    title: HTMLHeadingElement
    titlePlaceholderForCaretPosition: HTMLHeadingElement
  }

  @Prop({ default: null }) isCollapsed!: boolean | null
  @Getter builder!: User
  @Getter title!: string
  @Getter description!: string
  @Getter portrait!: string
  @Getter canIAdminister!: boolean
  @Getter backgroundLuminance!: 'light' | 'dark'
  @Getter colorScheme!: 'light' | 'dark'
  @Getter fontId!: number
  @Getter isMap!: boolean
  @State isEmbedded!: boolean
  @namespace('settings').Action showSettingsPanel!: () => void

  get portraitSize(): number {
    return 32
  }
  get fontClass(): string {
    return tailwindSurfaceFontClass(this.fontId)
  }

  get isBuilderRegistered(): boolean {
    return isRegistered(this.builder)
  }

  get builderProfileUrl(): string {
    return transformCurrentUrl({}, { path: this.builder.username })
  }

  @Watch('title')
  onTitleChanged(): void {
    this.$emit('title-changed')
  }

  @Watch('description')
  onDescriptionChanged(): void {
    this.$emit('description-changed')
  }

  @Watch('portrait')
  onPortraitChanged(): void {
    this.$emit('portrait-changed')
  }

  tryModify(): void {
    if (this.canIAdminister) {
      this.showSettingsPanel()
    }
  }
  isLongTitle = false
  @Watch('isCollapsed')
  @Watch('title')
  @Watch('portrait')
  updateCaretPosition(): void {
    if (this.$refs.title.offsetHeight > 26) {
      this.isLongTitle = true
    } else {
      this.isLongTitle = false
    }
    this.$refs.titlePlaceholderForCaretPosition.innerText = ''
    this.$nextTick(() => {
      if (!this.isCollapsed) {
        const titleWords = this.title.split(' ')
        let titleFirstLine = ''
        titleWords.every((word): boolean => {
          const nextTitleFirstLine = !titleFirstLine ? word : `${titleFirstLine} ${word}`
          this.$refs.titlePlaceholderForCaretPosition.innerText = nextTitleFirstLine
          if (this.$refs.titlePlaceholderForCaretPosition.offsetHeight > 26) {
            this.$refs.titlePlaceholderForCaretPosition.innerText = titleFirstLine
            return false
          }
          titleFirstLine = nextTitleFirstLine
          return true
        })
      } else {
        this.$refs.titlePlaceholderForCaretPosition.innerText = this.title
      }
    })
  }

  mounted(): void {
    this.updateCaretPosition()
  }
}
